















































































import { Component, Vue } from 'vue-property-decorator';
import user from '@/store/modules/user';
import { showLogin } from '@/config';

@Component
export default class Login extends Vue {
  username: string = '';
  password: string = '';

  login() {
    user.login({ Email: this.username, Password: this.password });
  }

  get loggingIn() {
    return user.loggingIn;
  }

  get showLogin() {
    return showLogin;
  }
}
